import { useSelector as useReduxState } from 'react-redux'

export {
  useReduxState
}



// WEBPACK FOOTER //
// ./src/hooks/reduxState.js